import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/app/src/containers/components/htmlContent/style.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/shared/components/searchTab/components/tabs/components/TabDrawer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/shared/components/searchTab/components/tabs/flight/FlightTab.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/shared/components/searchTab/components/tabs/hotel/HotelTab.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/shared/components/searchTab/components/tabs/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/shared/components/searchTab/components/tabs/tour/TourTab.tsx");
